import React, { Component } from 'react';

class ListaModelosSeleccionados extends Component {
    constructor(props) {
        super(props);

        this.guardarQuitarModeloSeleccionado = this.guardarQuitarModeloSeleccionado.bind(this);
    }

    guardarQuitarModeloSeleccionado(modelo, adicionarModelo) {
        this.props.guardarQuitarModeloSeleccionado( modelo, adicionarModelo);
    }

    render() {
        const {
            claseContenedor,
            considerarVerMas,
            modelosContablesSeleccionados,
            mostrarEtiquetaTodos,
            mostrarVerMas,
            todosModelosSeleccionados
        } = this.props;

        let arrayModelosSeleccionados = [];

        let linkVerMas = <div key={"verMas"} className="ContabilizadorRecontabilizador__linkVerMas"><span onClick={this.props.ocultarBotonVerMas}>Ver más...</span></div>

        if(todosModelosSeleccionados && mostrarEtiquetaTodos) {
            arrayModelosSeleccionados.push(
                <div key={"Todos"} className="btn-group ABMModelosModalContainer__botonModelo">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable ABMModelosModalContainer__botonModeloDescripcion">{"Todos"}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.guardarQuitarModeloSeleccionado("Todos", false)} >
                        <span className="ti-close span-closable color-white" title="Quitar Modelo"></span>
                    </button>
                </div>
            );
        } else {
            modelosContablesSeleccionados.map(modelo => {
                let descripcionModelo = modelo.Id == "Todos" ? modelo.Id : modelo.Id + " - " + modelo.Descripcion;
                descripcionModelo = descripcionModelo.length > 16 ? descripcionModelo.substr(0, 14) + String.fromCharCode(8230) : descripcionModelo;
                arrayModelosSeleccionados.push(
                    <div key={modelo.Id} className="btn-group ABMModelosModalContainer__botonModelo">
                        <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable ABMModelosModalContainer__botonModeloDescripcion">{descripcionModelo}</button>
                        <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.guardarQuitarModeloSeleccionado(modelo.Id, false)} >
                            <span className="ti-close span-closable color-white" title="Quitar Modelo"></span>
                        </button>
                    </div>
                )
            });
        }


        arrayModelosSeleccionados = considerarVerMas && arrayModelosSeleccionados.length > 8 && mostrarVerMas ?
                                        [...arrayModelosSeleccionados.slice(0,8), linkVerMas]
                                    : 
                                        arrayModelosSeleccionados;
        

        return (
            <div className={claseContenedor}>
                {arrayModelosSeleccionados}
            </div>
        );
    }
}

export default ListaModelosSeleccionados;
